import Vue from 'vue';
import VueX from 'vuex';

Vue.use(VueX);

const requireModule = require.context("./store_modules", true, /index.js/);
const modules = {};
requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\/index\.js)/g, "");
  modules[moduleName] = requireModule(fileName).default;
});

export default new VueX.Store({
  modules
});